export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylish%20modern%20workspace%20with%20laptop%20displaying%20spreadsheet%20data%20alongside%20fashion%20items%20and%20coffee%20cup%2C%20warm%20ambient%20lighting%20from%20window%2C%20cozy%20productive%20atmosphere%2C%20wooden%20desk%20texture%2C%20plants%20in%20background%2C%20editorial%20lifestyle%20photography%2C%20soft%20bokeh%20effect&width=1800&height=600&seq=kakobuy-cta-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet produkty"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/80 to-primary-800/70"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
          Korzystaj z najnowszego Kakobuy Spreadsheet
        </h2>
        <p className="text-white/80 text-sm md:text-base mb-8 max-w-xl mx-auto">
          Dołącz do tysięcy zadowolonych kupujących i odkryj najlepsze produkty z Chin. Szybciej, bezpieczniej i taniej.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-accent-500 hover:bg-accent-600 text-white font-semibold rounded-full text-sm md:text-base transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-accent-500/25"
          >
            <i className="ri-shopping-cart-2-line text-lg"></i>
            Kakobuy Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white font-semibold rounded-full text-sm md:text-base transition-all cursor-pointer whitespace-nowrap border border-white/25"
          >
            <i className="ri-flashlight-line text-lg"></i>
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}